<h2 mat-dialog-title>
  {{ data.type == 'create' ? 'Nueva intervención' : 'Actualización de intervención' }}
</h2>
<mat-dialog-content class="mat-typography">
  <div>
    <mat-card>
      <mat-card-title>Información de programación quirúrgica</mat-card-title>
      <mat-card-subtitle>Información de paciente y programación quirúrgica</mat-card-subtitle>
      <form [formGroup]="interventionForm">
        <mat-card-content>
          <mat-form-field appearance="outline">
            <mat-label>Fecha y hora de programación quirúrgica</mat-label>
            <input matInput type="datetime-local" formControlName="interventionDatetime" />
            <mat-error>
              Fecha y hora de programación quirúrgica es <strong>requerido</strong>
            </mat-error>
          </mat-form-field>

          <div>
            <h3>Tipo de cirugía:</h3>
            <mat-radio-group formControlName="type">
              <mat-radio-button value="Programada">Programada</mat-radio-button>
              <mat-radio-button value="Urgencia en turno">Urgencia en turno</mat-radio-button>
              <mat-radio-button value="Urgencia fuera de turno">Urgencia fuera de turno</mat-radio-button>
            </mat-radio-group>
            @if (interventionForm.get('type')?.touched && interventionForm.get('type')?.hasError('required')) {
              <div class="mat-error">
                La selección de una opción es <strong>requerida</strong>
              </div>
            }
          </div>

          <div>
            <h3>Datos del procedimiento:</h3>
            <mat-form-field class="input-width-50" appearance="outline">
              <mat-label>Hospital</mat-label>
              <mat-select formControlName="hospital" (selectionChange)="filterData()">
                @for (item of placesList; track item) {
                  <mat-option
                    [matTooltip]="item['name']"
                    matTooltipPosition="left"
                    [value]="item.id">
                    {{ placesObject[item.id] }}
                  </mat-option>
                }
              </mat-select>
              <mat-error> Hospital es <strong>requerido</strong> </mat-error>
            </mat-form-field>

            <mat-form-field class="input-width-50" appearance="outline">
              <mat-label>Quirofano</mat-label>
              <!-- Quirófano: campo abierto (igual que en el asistente de folio) -->
              <input matInput formControlName="operationRoom" autocomplete="off">
              <mat-error> Quirofano es <strong>requerido</strong> </mat-error>
            </mat-form-field>

            <mat-form-field class="input-width-50" appearance="outline">
              <mat-label>Episodio</mat-label>
              <input matInput formControlName="episode" />
            </mat-form-field>
            <mat-form-field class="input-width-50" appearance="outline">
              <mat-label>Especialidad</mat-label>
              <mat-select formControlName="specialty" (selectionChange)="filterData()">
                @for (item of specialtyList; track item) {
                  <mat-option
                    [matTooltip]="item['name']"
                    matTooltipPosition="left"
                    [value]="item.id">
                    {{ specialtyObject[item.id] }}
                  </mat-option>
                }
              </mat-select>
              <mat-error> Especialidad es <strong>requerido</strong> </mat-error>
            </mat-form-field>

            <mat-form-field class="input-width-50" appearance="outline">
              <mat-label>Procedimiento</mat-label>
              <mat-select formControlName="procedure">
                @for (item of procedureFilteredList; track item) {
                  <mat-option
                    [matTooltip]="item.name"
                    matTooltipPosition="left"
                    [value]="item.id">
                    {{ item.name }}
                  </mat-option>
                }
              </mat-select>
              <mat-error> Procedimiento es <strong>requerido</strong> </mat-error>
            </mat-form-field>

            <mat-form-field class="input-width-50" appearance="outline">
              <mat-label>Médico Tratante</mat-label>
              <mat-select formControlName="doctor">
                @for (item of doctorFilteredList; track item) {
                  <mat-option [value]="item.id">
                    {{ doctorObject[item.id] }}
                  </mat-option>
                }
              </mat-select>
              <mat-error> Médico Tratante es <strong>requerido</strong> </mat-error>
            </mat-form-field>

            <mat-form-field class="input-width-50" appearance="outline">
              <mat-label>Diagnóstico</mat-label>

              <input
                matInput
                type="text"
                formControlName="diagnosis"
                placeholder="Ingrese el diagnóstico"
                />
            </mat-form-field>
          </div>

          <div>
            <h3>Datos del paciente:</h3>

            <!-- Búsqueda de paciente con autocomplete -->
            <div class="patient-selection-container">
              <mat-form-field class="patient-search-field" appearance="outline">
                <mat-label>Buscar paciente (nombre, expediente o CURP)</mat-label>
                <input
                  type="text"
                  matInput
                  [formControl]="patientSearchControl"
                  [matAutocomplete]="autoPatient"
                  [disabled]="isCreatingPatient || isEditingPatient"
                  placeholder="Escribe para buscar...">
                @if (selectedPatient && !isCreatingPatient && !isEditingPatient) {<button mat-icon-button matSuffix (click)="clearPatientSelection()" type="button" matTooltip="Limpiar selección"><mat-icon>close</mat-icon></button>}
                <mat-autocomplete
                  #autoPatient="matAutocomplete"
                  (optionSelected)="onAutocompleteSelected($event)">
                  @for (patient of filteredPatients | async; track patient) {
                    <mat-option [value]="patient">
                      <div class="patient-option">
                        <span class="patient-name">{{ patientObject[patient.id]?.name }}</span>
                        <span class="patient-details">Exp: {{ patientObject[patient.id]?.identifier }}</span>
                        @if (patientObject[patient.id]?.CURP) {
                          <span class="patient-details">CURP: {{ patientObject[patient.id]?.CURP }}</span>
                        }
                      </div>
                    </mat-option>
                  }
                  @if ((filteredPatients | async)?.length === 0) {
                    <mat-option disabled>
                      <span class="no-results">No se encontraron pacientes</span>
                    </mat-option>
                  }
                </mat-autocomplete>
                @if (interventionForm.get('patient')?.hasError('required')) {<mat-error>Paciente es <strong>requerido</strong></mat-error>}
              </mat-form-field>

              <button
                mat-raised-button
                color="primary"
                type="button"
                (click)="startCreatingPatient()"
                [disabled]="isCreatingPatient || isEditingPatient"
                class="patient-action-btn">
                <mat-icon>person_add</mat-icon>
                Nuevo
              </button>

              <button
                mat-raised-button
                color="accent"
                type="button"
                (click)="startEditingPatient()"
                [disabled]="!selectedPatient || isCreatingPatient || isEditingPatient"
                class="patient-action-btn">
                <mat-icon>edit</mat-icon>
                Editar
              </button>
            </div>

            <!-- Campos del paciente -->
            @if (selectedPatient || isCreatingPatient) {
              <div class="patient-fields-container">
                <mat-form-field class="input-width-50" appearance="outline">
                  <mat-label>Nombre completo del paciente</mat-label>
                  <input matInput formControlName="patientName" />
                  <mat-error>
                    Nombre completo del paciente es <strong>requerido</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="input-width-50" appearance="outline">
                  <mat-label>CURP</mat-label>
                  <input matInput formControlName="curp" />
                </mat-form-field>
                <mat-form-field class="input-width-50" appearance="outline">
                  <mat-label>No. de expediente</mat-label>
                  <input matInput formControlName="record" />
                  <mat-error> No. de expediente es <strong>requerido</strong> </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Fecha de nacimiento</mat-label>
                  <input matInput type="date" formControlName="patientBirthdate" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Sexo del paciente</mat-label>
                  <mat-select formControlName="patientSex">
                    <mat-option value="Masculino"> Masculino </mat-option>
                    <mat-option value="Femenino"> Femenino </mat-option>
                  </mat-select>
                  <mat-error> Sexo del paciente es <strong>requerido</strong> </mat-error>
                </mat-form-field>
                <!-- Botones de acción para paciente -->
                @if (isCreatingPatient || isEditingPatient) {
                  <div class="patient-edit-actions">
                    <button
                      mat-raised-button
                      color="primary"
                      type="button"
                      (click)="isCreatingPatient ? saveNewPatient() : savePatientChanges()">
                      <mat-icon>save</mat-icon>
                      {{ isCreatingPatient ? 'Guardar Paciente' : 'Guardar Cambios' }}
                    </button>
                    <button
                      mat-raised-button
                      type="button"
                      (click)="cancelPatientEdit()">
                      <mat-icon>cancel</mat-icon>
                      Cancelar
                    </button>
                  </div>
                }
              </div>
            }
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>
    <mat-icon>close</mat-icon>
    Cancelar
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="data.type == 'create' ? createIntervention() : patchInterventions()"
    [disabled]="isCreatingPatient || isEditingPatient">
    <mat-icon>save</mat-icon>
    Guardar
  </button>
</mat-dialog-actions>